import React, {useContext, useEffect, useState} from "react";
import { Route, Switch } from "react-router-dom";
import NewObject from "../../../overbox/sheet/category/NewObject";
import ObjectSheet from "../../../sheet/ObjectSheet";
import Listing from "../../../table/Listing";
import usePrevious from "../../../../class/tool/usePrevious";
import FilterPopup from "../../../table/FilterPopup";
import CategoryController from "../../../../stories/_catalog/Categories/CategoryController";
import CatalogController from "../../../../stories/_catalog/Catalogs/CatalogController";
import ListingContext from "../../../../context/ListingContext";
import BackofficeContext from "../../../../context/BackofficeContext";
import "../../../../css/page/content/category/Category.css";

const Categories = () => {
    const item = "categories";
    const itemClass = "category";
    const titleWindow = "Catégories";
    const placeholderSearch = "une catégorie";
    const titleNbItems = "catégories";
    const emptyList = "Aucune catégorie";
    const textRemoveButton = "cette catégorie";
    const activeHistory = false;
    const settings = JSON.parse(localStorage.getItem("storeSettings"));
    const defaultCatalog = JSON.parse(localStorage.getItem("catalog"));
    const company = JSON.parse(localStorage.getItem("company"));
    const { setEvent } = useContext(BackofficeContext);
    const [ pageSelect, setPageSelect ] = useState(1);
    const [ loading, setLoading ] = useState(true);
    const [ model, setModel ] = useState([
        {
            "class": "name",
            "sortingParam": "name",
            "title": "Nom",
            "attributes": ["name"],
            "type": "text"
        },
        {
            "class": "reference",
            "sortingParam": "reference",
            "title": "Référence",
            "attributes": ["reference"],
            "type": "text"
        }
    ]);
    const [ list, setList ] = useState([]);
    const [ options, setOptions ] = useState([]);
    const [ secondaryOptions, setSecondaryOptions ] = useState([]);
    const [ catalogId, setCatalogId ] = useState(Object.keys(defaultCatalog).length > 0 ? defaultCatalog.id : null);
    const [ pagination, setPagination ] = useState(null);
    const [ perPage, setPerPage ] = useState(25);
    const [ sortingName, setSortingName ] = useState("updated_at");
    const [ sortingValue, setSortingValue ] = useState("desc");
    const [ catalogs, setCatalogs ] = useState([]);
    const [ filters, setFilters ] = useState({});
    const [ filterValues, setFilterValues ] = useState({});
    const [ contextValues, setContextValues ] = useState({});
    const [ showFilters, setShowFilters ] = useState(false);
    const prevPageSelect = usePrevious(pageSelect);
    const prevPerPage = usePrevious(perPage);

    const initModel = () => {
        let modelsTmp = model.slice();

        if (Object.keys(defaultCatalog).length === 0) {
            modelsTmp.splice(2, 0, {
                "class": "catalogName",
                "sortingParam": "catalog_name",
                "title": "Catalogue",
                "attributes": ["catalog_name"],
                "type": "catalogName"
            });
        }

        setModel(modelsTmp);
    }
    const initFilters = () => {
        setFilterValues(prev => ({
            ...prev,
            catalog_id: catalogId,
            inputs: [],
            input: null
        }));
    }
    const initOptions = () => {
        let optionsTmp = [];
        let secondaryOtionsTmp = [];

        if (settings === null || company.socialReason === null || (company.socialReason !== null && settings.allowedProductCreation === 1)) {
            optionsTmp.push({
                "class": "add moreActions",
                "title": "Créer " + placeholderSearch,
                "action": "",
                "link": "/" + item + "/new"
            });

            secondaryOtionsTmp.push({
                "class": "blue addMany",
                "title": "Ajouter plusieurs " + titleNbItems,
                "action": "handleAddMany",
                "link": ""
            });
        }

        setOptions(optionsTmp);
        setSecondaryOptions(secondaryOtionsTmp);
    }
    const getCategories = (pPage = 1, pPerPage = 25, pSortingName = "", pSortingValue = "") => {
        let controller = new CategoryController();
        let paramPage = pPage !== 1 ? pPage : pageSelect;
        let paramPerPage = pPerPage !== 25 ? pPerPage : perPage;
        let paramSortingName = pSortingName !== "" ? pSortingName : sortingName;
        let paramSortingValue = pSortingValue !== "" ? pSortingValue : sortingValue;

        setLoading(true);

        controller._callback = handleGetCategories;
        controller.index(filterValues, paramPage, paramPerPage, paramSortingName, paramSortingValue, false);
    }
    const handleGetCategories = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                setList(list);
                setPagination(pagination !== undefined ? pagination : null );

                break;
            default:
                setEvent({
                    type: "error",
                    text: "Une erreur s'est produite lors de la récupération des produits"
                });
                break;
        }

        setLoading(false);
    }
    const getCatalogs = () => {
        const controller = new CatalogController()
        controller._callback = handleGetCatalogs
        controller.index(null, 0, 0, "name", "asc", true);
    }
    const handleGetCatalogs = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                localStorage.setItem("catalogs", JSON.stringify(list))

                if (list.length === 1)
                    localStorage.setItem("catalog", JSON.stringify(list[0]))
                else
                    localStorage.setItem("catalog", JSON.stringify({}))

                let listTmp = [];

                for (let i in list) {
                    listTmp.push({
                        name: list[i].name,
                        id: list[i].id,
                        object: list[i]
                    })
                }

                setCatalogs(listTmp);

                break
            default: break;
        }
    }
    const updateFilters = () => {
        setFilters(prev => ({
            ...prev,
            catalogs: catalogs
        }));
    }
    const updatePageSelect = page => {
        setPageSelect(page);
    }
    const handleRefresh = (force = true) => {
        if (force) {
            if (pageSelect !== 1) {
                setPageSelect(1);
                return;
            }
        }

        getCategories(pageSelect, perPage, sortingName, sortingValue);
    }
    const handleUpdate = object => {
        let index = list.findIndex(item => item.id === object.id);
        if (index < 0) return;

        let listTmp = list.slice();
        let keys = Object.keys(listTmp[index]);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (object[key] !== undefined)
                listTmp[index][key] = object[key];
        }

        setList(listTmp);
    }
    const handleRemove = () => {
        handleRefresh();
    }
    const openFilters = () => {
        setShowFilters(true);
    }
    const closeFilters = () => {
        setShowFilters(false);
    }
    const validFilters = values => {
        closeFilters();
        setFilterValues(values);
    }

    useEffect(() => {
        document.title = "Back office - " + titleWindow;

        getCatalogs();
        initModel();
        initFilters();
        initOptions();
    }, []);
    useEffect(() => {
        updateFilters();
    }, [catalogs]);
    useEffect(() => {
        if (prevPageSelect === undefined || prevPerPage === undefined) return;

        if (pageSelect !== prevPageSelect || perPage !== prevPerPage)
            handleRefresh(false);
    }, [pageSelect, perPage]);
    useEffect(() => {
        if (Object.keys(filterValues).length === 0) return;

        setCatalogId(filterValues.catalog_id);
        handleRefresh(true);
    }, [filterValues]);
    useEffect(() => {
        setContextValues(prev => ({
            ...prev,
            page: pageSelect,
            typeFilters: "categories",
            filters,
            filterValues,
            showFilters,
            openFilters,
            closeFilters,
            validFilters
        }));
    }, [showFilters, pageSelect, filters, filterValues]);

    return(
        <ListingContext.Provider value={contextValues}>
            <FilterPopup />
            <Listing
                item={ item }
                itemClass={ itemClass }
                placeholderSearch={ placeholderSearch }
                titleNbItems={ titleNbItems }
                emptyList={ emptyList }
                model={ model }
                options={ options }
                secondaryOptions={ secondaryOptions }
                activeHistory={ activeHistory }
                pageSelect={ pageSelect }
                updatePageSelect={ updatePageSelect }
                list={ list }
                loading={ loading }
                pagination={ pagination }
                checkable={ false }
                openable={ true }
                setPerPage={ setPerPage }
                sortingName={ sortingName }
                sortingValue={ sortingValue }
                setSortingName={ setSortingName }
                setSortingValue={ setSortingValue }
            />
            <Switch>
                <Route exact path={ "/categories/new" }>
                    <NewObject list={ list } handleIndex={ handleRefresh } />
                </Route>
                <Route path={ "/catalogs/:idCatalog/categories/:id/(information|stats)" }>
                    <ObjectSheet
                        objectType={ itemClass }
                        previousLink={ item }
                        textRemoveButton={ textRemoveButton }
                        handleUpdate={ handleUpdate }
                        handleRemove={ handleRemove } />
                </Route>
            </Switch>
        </ListingContext.Provider>
    )
}

export default Categories;
